const INIT_PLAYER: string = 'song/INIT_PLAYER' as const;
const INIT_SRC: string = 'song/INIT_SRC' as const;
const SET_SRC: string = 'song/SET_SRC' as const;
const SET_SONG_INFO: string = 'song/SET_SONG_INFO' as const;
const INIT_SONG_INFO: string = 'song/INIT_SONG_INFO' as const;
const DISPLAY_PLAYER: string = 'song/DISPLAY_PLAYER' as const;
const Close_PLAYER: string = 'song/CLOSE_PLAYER' as const;
const SETISPLAY: string = 'song/SETISPLAY' as const;
const SETPLAYID: string = 'song/SETPLAYID' as const;

interface SongProps {
    imgSrc: string,
    title: string,
    artist: string,
    folder: string,
}

type initPlayerAction = {
    type: typeof INIT_PLAYER;
    payload: any;
};
type initSrcAction = {
    type: typeof INIT_SRC;
    payload: string;
}
type setSrcAction = {
    type: typeof SET_SRC;
    payload: string;
}
type setSongInfoAction = {
    type: typeof SET_SONG_INFO;
    payload: SongProps;
}
type initSongInfoAction = {
    type: typeof INIT_SONG_INFO;
    payload: null;
}
type displayPlayerAction = {
    type: typeof DISPLAY_PLAYER;
    payload: boolean;
}
type closePlayerAction = {
    type: typeof Close_PLAYER;
    payload: boolean;
}
type setIsPlayAction = {
    type: typeof SETISPLAY;
    payload: boolean;
}
type setPlayIdAction = {
    type: typeof SETPLAYID;
    payload: string;
}

type ActionType = |
    initPlayerAction |
    initSrcAction |
    setSrcAction |
    setSongInfoAction |
    initSongInfoAction |
    displayPlayerAction |
    closePlayerAction | 
    setIsPlayAction | 
    setPlayIdAction;

export const initPlayer = (ref: any) => ({type: INIT_PLAYER, payload: ref});
export const initSrc = () => ({type: INIT_SRC, payload: ''});
export const setSrc = (src: string) => ({type: SET_SRC, payload: src});
export const setSongInfo = (songInfo: SongProps) => ({type: SET_SONG_INFO, payload: songInfo});
export const initSongInfo = () => ({type: INIT_SONG_INFO});
export const displayPlayer = () => ({type: DISPLAY_PLAYER, payload: true});
export const closePlayer = () => ({type: Close_PLAYER, payload: false});
export const setIsPlay = (isPlay: boolean) => ({type: SETISPLAY, payload: isPlay});
export const setPlayId = (id: string) => ({type: SETPLAYID, payload: id});

interface InitialStateType {
    player: any,
    src: string,
    id: string,
    songInfo: SongProps,
    display: boolean,
    isPlay: boolean
};

const initialSongState = {imgSrc: '', title: '', artist: '', folder: ''}
const initialState: InitialStateType = {
    player: undefined,
    src: '',
    id: '',
    songInfo: initialSongState,
    display: false,
    isPlay: false,
};

export default function song(state: InitialStateType = initialState, action: ActionType) {
    switch(action.type) {
        case INIT_PLAYER:
            return {
                ...state,
                ref: action.payload,
            };
        case INIT_SRC:
            return {
                ...state,
                src: action.payload,
            };
        case SET_SRC:
            return {
                ...state,
                src: action.payload,
            };
        case SET_SONG_INFO:
            return {
                ...state,
                songInfo: action.payload,
            };
        case INIT_SONG_INFO:
            return {
                ...state,
                songInfo: initialSongState,
            };
        case DISPLAY_PLAYER:
            return {
                ...state,
                display: action.payload
            };
        case Close_PLAYER:
            return {
                ...state,
                songInfo: initSongInfo,
                id: '',
                display: action.payload,
            };
        case SETISPLAY:
            return {
                ...state,
                isPlay: action.payload,
            };
        case SETPLAYID:
            return {
                ...state,
                id: action.payload,
            };
        default:
            return state;
    }
};